// ================ Action types ================ //

export const IS_OPEN_SET = 'app/UpgradePlanModal/IS_OPEN_SET';

const initialState = {
  isOpen: false,
}

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case IS_OPEN_SET:
      return {
        ...state,
        isOpen: payload,
      };

    default:
      return state;
  }
}

// ================ Selectors ================ //

const $subState = state => {
  return state.UpgradePlanModal;
};

export const $upgradePlanModalState = state => {
  const subState = $subState(state);
  return {
    isOpen: subState.isOpen,
  };
};

// ================ Action creators ================ //

export const isOpenSet = value => ({
  type: IS_OPEN_SET,
  payload: value,
});

// ================ Thunk ================ //

export const openModal = () => dispatch => {
  dispatch(isOpenSet(true));
};

export const closeModal = () => dispatch => {
  dispatch(isOpenSet(false));
};
